import { collection, where } from 'firebase/firestore';
import { firestore } from 'firebaseService/firebase';
import FirebaseFirestoreService from 'firebaseService/firebaseFirestore';
import FirebaseStorageService from 'firebaseService/firebaseStorage';

class CybersecurityFirestoreService extends FirebaseFirestoreService {
  static collectionPath = 'resources';
  static collection = collection(firestore, this.collectionPath);

  static async createCybersecurity(values) {
    try {
      let iconSrc = 'RESOURCES/DEFAULT/default.jpg';

      if (values.icon && values.icon instanceof File) {
        iconSrc = await this.uploadIcon(values.icon);
        delete values.icon;
      }

      const data = { ...values, iconSrc };
      const result = await this.addDoc(this.collection, data);
      return { success: true, result };
    } catch (error) {
      console.error(error);
      return { success: false, error };
    }
  }

  static async updateCybersecurity(values) {
    try {
      if (!values.icon.uploaded) {
        const iconSrc = await this.uploadIcon(values.icon);
        values.iconSrc = iconSrc;
      }

      delete values.icon;

      const result = await this.updateDoc(this.collectionPath, values.id, values);
      return { success: true, result };
    } catch (error) {
      console.error(error);
      return { success: false, error };
    }
  }

  static async uploadIcon(icon) {
    const iconPath = `RESOURCES/CYBERSECURITY/ICON/${icon.name}`;
    await FirebaseStorageService.uploadFile(iconPath, icon);
    return iconPath;
  }

  static async deleteCybersecurity(documentId) {
    try {
      return await this.deleteDoc(this.collectionPath, documentId);
    } catch (error) {
      return { success: false, error };
    }
  }

  static async reactivateCybersecurity(documentId) {
    try {
      return await this.reactivateDoc(this.collectionPath, documentId);
    } catch (error) {
      return { success: false, error };
    }
  }

  static subscribeToResourcesCybersecurity(callBack) {
    try {
      const constrains = [where('isActive', '==', true), where('type', '==', 'Ciberseguridad')];

      const unsubscibe = FirebaseFirestoreService.subscribeToAllDocs(this.collection, constrains, callBack);
      return unsubscibe;
    } catch (error) {
      return { success: false, error };
    }
  }

  static subscribeToResourcesDisabledCybersecurity(callBack) {
    try {
      const constrains = [where('isActive', '==', false), where('type', '==', 'Ciberseguridad')];

      const unsubscibe = FirebaseFirestoreService.subscribeToAllDocs(this.collection, constrains, callBack);
      return unsubscibe;
    } catch (error) {
      return { success: false, error };
    }
  }
}

export default CybersecurityFirestoreService;
